// Version : 0.0.2
// Author : DINESH
// MODFIED DATA : 07-08-2025

import StaffActionTypes from './staff.types';

/** ***************** GET STAFF LIST START *********************** */
export const getStaffListStart = (getData: any) => ({
	type: StaffActionTypes.GET_STAFF_LIST_START,
	payload: getData,
});

export const getStaffListSuccess = (successData: any) => ({
	type: StaffActionTypes.GET_STAFF_LIST_SUCCESS,
	payload: successData,
});

export const getStaffListFailure = (failureData: any) => ({
	type: StaffActionTypes.GET_STAFF_LIST_FAILURE,
	payload: failureData,
});

export const getStaffListResponseResetStart = () => ({
	type: StaffActionTypes.GET_STAFF_LIST_RESPONSE_RESET,
});

export const getStaffListResponseChanged = () => ({
	type: StaffActionTypes.GET_STAFF_LIST_RESPONSE_CHANGED,
});
/** ***************** GET STAFF LIST END *********************** */

/** ***************** PUBLISH STAFF DETAILS START *********************** */
export const updateIsPublishStatusStart = (publishData: any) => ({
	type: StaffActionTypes.UPDATE_ISPUBLISH_STATUS_START,
	payload: publishData,
});

export const updateIsPublishStatusSuccess = (successData: any) => ({
	type: StaffActionTypes.UPDATE_ISPUBLISH_STATUS_SUCCESS,
	payload: successData,
});

export const updateIsPublishStatusFailure = (failureData: any) => ({
	type: StaffActionTypes.UPDATE_ISPUBLISH_STATUS_FAILURE,
	payload: failureData,
});

export const updateIsPublishStatusResponseResetStart = () => ({
	type: StaffActionTypes.UPDATE_ISPUBLISH_STATUS_RESPONSE_RESET,
});

export const updateIsPublishStatusResponseChanged = () => ({
	type: StaffActionTypes.UPDATE_ISPUBLISH_STATUS_RESPONSE_CHANGED,
});

/** ***************** PUBLISH STAFF DETAILS END *********************** */

/** ***************** DELETE STAFF DETAILS START *********************** */
export const deleteStaffDetailsStart = (deleteData: any) => ({
	type: StaffActionTypes.DELETE_STAFF_DETAILS_START,
	payload: deleteData,
});

export const deleteStaffDetailsSuccess = (successData: any) => ({
	type: StaffActionTypes.DELETE_STAFF_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteStaffDetailsFailure = (failureData: any) => ({
	type: StaffActionTypes.DELETE_STAFF_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteStaffDetailsResponseResetStart = () => ({
	type: StaffActionTypes.DELETE_STAFF_DETAILS_RESPONSE_RESET,
});

export const deleteStaffDetailsResponseChanged = () => ({
	type: StaffActionTypes.DELETE_STAFF_DETAILS_RESPONSE_CHANGED,
});

/** ***************** DELETE STAFF DETAILS END *********************** */

/** ***************** ADD STAFF DETAILS START *********************** */
export const addStaffDetailsStart = (addData: any) => ({
	type: StaffActionTypes.ADD_STAFF_DETAILS_START,
	payload: addData,
});

export const addStaffDetailsSuccess = (successData: any) => ({
	type: StaffActionTypes.ADD_STAFF_DETAILS_SUCCESS,
	payload: successData,
});

export const addStaffDetailsFailure = (failureData: any) => ({
	type: StaffActionTypes.ADD_STAFF_DETAILS_FAILURE,
	payload: failureData,
});

export const addStaffDetailsResponseResetStart = () => ({
	type: StaffActionTypes.ADD_STAFF_DETAILS_RESPONSE_RESET,
});

export const addStaffDetailsResponseChanged = () => ({
	type: StaffActionTypes.ADD_STAFF_DETAILS_RESPONSE_CHANGED,
});

/** ***************** ADD STAFF DETAILS END *********************** */

/** ***************** FETCH STAFF DETAILS START *********************** */
export const fetchStaffDetailsStart = (fetchData: any) => ({
	type: StaffActionTypes.FETCH_STAFF_DETAILS_START,
	payload: fetchData,
});

export const fetchStaffDetailsSuccess = (successData: any) => ({
	type: StaffActionTypes.FETCH_STAFF_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchStaffDetailsFailure = (failureData: any) => ({
	type: StaffActionTypes.FETCH_STAFF_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchStaffDetailsResponseResetStart = () => ({
	type: StaffActionTypes.FETCH_STAFF_DETAILS_RESPONSE_RESET,
});

export const fetchStaffDetailsResponseChanged = () => ({
	type: StaffActionTypes.FETCH_STAFF_DETAILS_RESPONSE_CHANGED,
});

export const fetchStaffDetailsResetComponentStart = () => ({
	type: StaffActionTypes.FETCH_STAFF_DETAILS_RESET_COMPONENT_START,
});

/** ***************** FETCH STAFF DETAILS END *********************** */

/** ***************** UPDATE STAFF DETAILS START *********************** */
export const updateStaffDetailsStart = (updateData: any) => ({
	type: StaffActionTypes.UPDATE_STAFF_DETAILS_START,
	payload: updateData,
});

export const updateStaffDetailsSuccess = (successData: any) => ({
	type: StaffActionTypes.UPDATE_STAFF_DETAILS_SUCCESS,
	payload: successData,
});

export const updateStaffDetailsFailure = (failureData: any) => ({
	type: StaffActionTypes.UPDATE_STAFF_DETAILS_FAILURE,
	payload: failureData,
});

export const updateStaffDetailsResponseResetStart = () => ({
	type: StaffActionTypes.UPDATE_STAFF_DETAILS_RESPONSE_RESET,
});

export const updateStaffDetailsResponseChanged = () => ({
	type: StaffActionTypes.UPDATE_STAFF_DETAILS_RESPONSE_CHANGED,
});

/** ***************** UPDATE STAFF DETAILS END *********************** */

/** ***************** ISPRINT STAFF DETAILS START *********************** */
export const updateIsPrintStaffStart = (publishData: any) => ({
	type: StaffActionTypes.UPDATE_ISPRINT_STAFF_START,
	payload: publishData,
});

export const updateIsPrintStaffSuccess = (successData: any) => ({
	type: StaffActionTypes.UPDATE_ISPRINT_STAFF_SUCCESS,
	payload: successData,
});

export const updateIsPrintStaffFailure = (failureData: any) => ({
	type: StaffActionTypes.UPDATE_ISPRINT_STAFF_FAILURE,
	payload: failureData,
});

export const updateIsPrintStaffResponseResetStart = () => ({
	type: StaffActionTypes.UPDATE_ISPRINT_STAFF_RESPONSE_RESET,
});

export const updateIsPrintStaffResponseChanged = () => ({
	type: StaffActionTypes.UPDATE_ISPRINT_STAFF_RESPONSE_CHANGED,
});

/** ***************** ISPRINT STAFF DETAILS END *********************** */

/** ***************** GET ALL STAFF START *********************** */
export const getAllStaffStart = (getData: any) => ({
	type: StaffActionTypes.GET_ALL_STAFF_START,
	payload: getData,
});

export const getAllStaffSuccess = (successData: any) => ({
	type: StaffActionTypes.GET_ALL_STAFF_SUCCESS,
	payload: successData,
});

export const getAllStaffFailure = (failureData: any) => ({
	type: StaffActionTypes.GET_ALL_STAFF_FAILURE,
	payload: failureData,
});

export const getAllStaffResponseResetStart = () => ({
	type: StaffActionTypes.GET_ALL_STAFF_RESPONSE_RESET,
});

export const getAllStaffResponseChanged = () => ({
	type: StaffActionTypes.GET_ALL_STAFF_RESPONSE_CHANGED,
});
/** ***************** GET ALL STAFF END *********************** */
